import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {
  @Input() showheader: any;
  @Input() data: any = {}
  baseUrl = environment.imgUrl;
  eventArr
  eventId
  loading = false
  arr = [1, 2, 3, 4, 5]
  expiredEvents = []
  upcomingEvents = []
  currentDate
  constructor(private authService: AuthservicesService, private router: Router) {


  }
  ngOnInit(): void {
    this.currentDate = moment().format()

    this.getAlerts()
  }


  getAlerts() {
    this.loading = false;
    this.authService.getEventswithoutLoader(true, 0, 5).subscribe((res: any) => {
      this.eventArr = res.items;
      this.eventArr.forEach(e => {
        let res = moment(e.validTill).isAfter(this.currentDate); //true
        if (!res) {
          this.expiredEvents.push(e)
        }
        else if (res) {
          this.upcomingEvents.push(e)
        }
      });
      this.loading = true;
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }

  navigate(id) {
    this.eventId = id;
    this.router.navigate(['/event-manager/detail-event', this.eventId])
  }

  renderImage(image: any) {
    if (image !== undefined || image !== null) {
      const [baseUrl, imgUrl] = image.split('uploads');
      return `${this.baseUrl}uploads${imgUrl}`
    } else {
      return 'assets/images/church.jpeg'
    }
  }

  getErrorImage(event) {
    this.authService.geterrorImage(event)
  }

}
